import settingsModule from '../../settings.module';

class PermissionService {
    constructor(
        $q,
        $sessionStorage,
        accountApiService,
        accountProvider,
        authenticationService,
        permissionApiService
    ) {
        this.$q = $q;
        this.$sessionStorage = $sessionStorage;
        this.accountApiService = accountApiService;
        this.accountProvider = accountProvider;
        this.authenticationService = authenticationService;
        this.permissionApiService = permissionApiService;
    }

    getPermissions(moduleName) {
        return this.permissionApiService.getPermissions(moduleName);
    }

    getPermissionsOfUser(userGuid, moduleName) {
        return this.permissionApiService.getPermissionsOfUser(
            userGuid,
            moduleName
        );
    }

    getUsersOfAccount(search, userType) {
        var deferred = this.$q.defer();
        this.accountProvider.getAccountGuid().then(accountGuid => {
            this.accountApiService
                .getUsersOfAccount(accountGuid, search, userType)
                .then(deferred.resolve, deferred.reject);
        }, deferred.reject);
        return deferred.promise;
    }

    getUserPermissionsOfAccount(moduleName) {
        var deferred = this.$q.defer();
        this.accountProvider.getAccountGuid().then(accountGuid => {
            this.permissionApiService
                .getUserPermissionsOfAccount(accountGuid, moduleName)
                .then(deferred.resolve, deferred.reject);
        }, deferred.reject);
        return deferred.promise;
    }

    createUserPermissions(userPermissions) {
        var deferred = this.$q.defer();

        this.authenticationService.getToken().then(cloudToken => {
            this.accountProvider.getAccountGuid().then(accountGuid => {
                this.permissionApiService
                    .createUserPermissions(
                        cloudToken,
                        accountGuid,
                        userPermissions
                    )
                    .then(deferred.resolve, deferred.reject);
            }, deferred.reject);
        }, deferred.reject);

        return deferred.promise;
    }
}

export default settingsModule.service('permissionService', PermissionService);



// WEBPACK FOOTER //
// ./modules/settings/services/permission/permission.service.js